import { PreferencesState } from '@abb-procure/data';
import { BooleanInput } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  booleanAttribute,
  computed,
  inject,
  input,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { Router, RouterLink } from '@angular/router';
import { QuicklinkDirective } from 'ngx-quicklink';
import { ViewNavigationService } from '../../services/view-navigation.service';
import { Menu } from '../menu/menu.component';

@Component({
  selector: 'procure-menu-child',
  templateUrl: './menu-child.component.html',
  styleUrl: './menu-child.component.scss',
  imports: [RouterLink, MatTooltip, QuicklinkDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuChild {
  readonly route = input<(string | null | undefined)[]>([]);
  readonly parent = input<(string | null | undefined)[]>([]);
  readonly view = input<string>();
  readonly tooltip = input<string>();
  readonly label = input<string>();

  readonly active = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly last = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly first = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly show = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly selected = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  protected readonly itemTooltip = computed(() =>
    !this.expanded() ? this.label() : this.tooltip(),
  );

  protected readonly isDimHighlight = computed(
    () => this.menu?.dimActive() ?? false,
  );

  protected readonly expanded = inject(PreferencesState).isNavigationExpanded;
  protected readonly viewNavigationService = inject(ViewNavigationService);

  private readonly menu = inject(Menu, { optional: true });
  private readonly router = inject(Router);

  protected navigate(): void {
    const parent = this.parent();
    const view = this.view();

    if (view) {
      this.viewNavigationService.setActiveView(view);
    }

    if (parent) {
      void this.router.navigate(parent, {
        queryParams: view ? { view } : undefined,
        queryParamsHandling: 'merge',
      });
    }
  }
}
